import { h } from 'preact'
import { i18n } from 'i18n/i18n'

const CalculatorHeader = () => {
  return <h2 className="calc-widget__title">{i18n('calculator.title')}</h2>
}

export default CalculatorHeader
